import { ReactFCC, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const Wrapper = styled.span`
  font-size: inherit;
  line-height: inherit;
`;

export const PriceBelowMinConditionWrapper = styled.span`
  ${theme.typography.labelRegular}
`;

export const TextIcon = styled.div<{ bgColor: string }>`
  background-color: ${(props) => props.bgColor};
  color: ${theme.color.text.inverse};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MinPriceWrapper = styled.div`
  ${theme.typography.labelRegular400}
  color: ${theme.color.text.secondary};
  display: flex;
  justify-content: flex-end;
  margin: -3px 0 0.5rem 0;
  svg {
    translate: 0 -2px;
  }
`;

export const CurrencyWrapper = styled(Wrapper)<{
  isSpaced: boolean;
  isPrefix: boolean;
}>`
  &:before {
    content: ${(props) => (props.isSpaced && !props.isPrefix ? '" "' : '')};
  }
  &:after {
    content: ${(props) => (props.isSpaced && props.isPrefix ? '" "' : '')};
  }
` as ReactFCC;

export const LineWrapper = styled.div`
  margin-bottom: 0.75rem;
`;

export const Slash = styled.span`
  padding: 0 0.25rem;
`;

export const Divider = styled.div`
  border-bottom: dashed ${theme.color.common.gray80} 1px;
  margin: 0.3rem 0 0.45rem;
`;
